import MockResource from "./mock.resource";

const mockModule = angular
  .module("app.resources.mock", [])
  .service("Mock", MockResource);

export default mockModule;



// WEBPACK FOOTER //
// ./src/resources/mock/mock.module.js